// extracted by mini-css-extract-plugin
module.exports = {"time":"style_time__3eD0C","timeContainer":"style_timeContainer__E1oc8"};